import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "pa-4 d-flex items-center" }
const _hoisted_3 = {
  class: "text-center",
  style: {"font-size":"26px"}
}
const _hoisted_4 = { class: "pt-4" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "pb-4 desc" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "pb-4 desc" }
const _hoisted_9 = { class: "title" }
const _hoisted_10 = { class: "desc" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_cell = _resolveComponent("van-cell")!
  const _component_van_cell_group = _resolveComponent("van-cell-group")!
  const _component_my_card_body = _resolveComponent("my-card-body")!
  const _component_my_card = _resolveComponent("my-card")!
  const _component_van_dialog = _resolveComponent("van-dialog")!

  return ($setup.deductOfItems.filter((it) => $props.analysis[it.key]).length)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_my_card, { class: "mt-4" }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _cache[1] || (_cache[1] = _createElementVNode("i", { class: "iconfont iconreport-icon-jiexi title-icon" }, null, -1)),
              _createTextVNode(" " + _toDisplayString(_ctx.$t("deduct.analysisOofSleepDeductionPoints")), 1)
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_my_card_body, null, {
              default: _withCtx(() => [
                _createVNode(_component_van_cell_group, { border: false }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.deductOfItems, (item, key) => {
                      return (_openBlock(), _createElementBlock(_Fragment, { key: key }, [
                        ($props.analysis[item.key])
                          ? (_openBlock(), _createBlock(_component_van_cell, {
                              key: 0,
                              class: "py-3 cell-item",
                              title: item.title,
                              value: `-${$props.analysis[item.key]}`,
                              onClick: ($event: any) => ($setup.show(item.key))
                            }, null, 8, ["title", "value", "onClick"]))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_van_dialog, {
          show: $setup.dialogShow,
          "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => (($setup.dialogShow) = $event)),
          "show-confirm-button": false,
          "close-on-click-overlay": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_my_card, { class: "pa-4" }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, _toDisplayString($setup.deductOfItem.title), 1)
              ]),
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t("deduct.factor")), 1),
                  _createElementVNode("div", _hoisted_6, _toDisplayString($setup.deductOfItem.factor), 1),
                  _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("deduct.analysis")), 1),
                  _createElementVNode("div", _hoisted_8, _toDisplayString($setup.deductOfItem.analysis), 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("deduct.recommendation")), 1),
                  _createElementVNode("div", _hoisted_10, _toDisplayString($setup.deductOfItem.proposal), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["show"])
      ]))
    : _createCommentVNode("", true)
}